export class Datavalue {
  pname: string;
  pvalue: string;
}
